export const pong = (): string => JSON.stringify({ type: 'pong' });
